import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./pages/home";
import Events from "./pages/events";
import SystemMonitor from "./pages/system-monitor";
import TranscriptUpload from "./pages/transcript-upload";
import EventDetailPage from "./pages/events/[id]";
import SessionDetailNewPage from "./pages/sessions/[id].new";
import SessionEditPage from "./pages/sessions/[id].edit";
import ReportEditorPage from "./pages/sessions/[id].report.edit";
import SettingsPage from "./pages/settings";
import { LoginForm } from "./pages/login/LoginForm";
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import SessionsPage from "./pages/sessions";
import { Provider } from "react-redux";
import store from "./redux/store";
import KeyboardShortcuts from "./components/global/KeyboardShortcuts";
import SearchPalette from "./components/global/SearchPalette";

function AppContent() {
  const [user, setUser] = useState(null);
  const [shortcutsOpen, setShortcutsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const loggedInUser = localStorage.getItem('diploAccessUser');
    setUser(loggedInUser);
  }, []);

  // Global keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      const target = e.target;
      const isInput = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
      
      // Ctrl+K or Cmd+K to open search
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
      // ? key to open shortcuts
      else if (e.key === '?' && !e.ctrlKey && !e.metaKey && !e.altKey && !isInput) {
        setShortcutsOpen(true);
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // If user is not logged in and we're not on login page, show login form
  if (!user && window.location.pathname !== '/login') {
    return <LoginForm />;
  }

  return (
    <>
      {user && <Header />}
      <main>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/" exact element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/system-monitor" element={<SystemMonitor />} />
          <Route path="/upload" element={<TranscriptUpload />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/sessions/:id/edit" element={<SessionEditPage />} />
          <Route path="/sessions/:id/report/edit" element={<ReportEditorPage />} />
          <Route path="/sessions/:id" element={<SessionDetailNewPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
      {/* {user && <Footer />} */}
      <KeyboardShortcuts isOpen={shortcutsOpen} onClose={() => setShortcutsOpen(false)} />
      <SearchPalette isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
